import BarChartsPage from 'components/PepwiseV2DemoDashboard/BarChartsPage';
import ButtonsPage from 'components/PepwiseV2DemoDashboard/ButtonsPage';
import DemoDashboardHome from 'components/PepwiseV2DemoDashboard/DemoDashboardHome';
import DemoDashboardWithWidgets from 'components/PepwiseV2DemoDashboard/DemoDashboardWithWidgets';
import AdvanceFilters from 'components/PepwiseV2DemoDashboard/FiltersDemoPage';
import FormInputsPage from 'components/PepwiseV2DemoDashboard/FormInputsPage';
import KPICardsDemoPage from 'components/PepwiseV2DemoDashboard/KPICardsDemoPage';
import KpiTilePage from 'components/PepwiseV2DemoDashboard/KpiTilePage';
import LineChartsPage from 'components/PepwiseV2DemoDashboard/LineChartsPage';
import MetricPage from 'components/PepwiseV2DemoDashboard/MetricPage';
import ModalsPage from 'components/PepwiseV2DemoDashboard/ModalsPage';
import PieChartsPage from 'components/PepwiseV2DemoDashboard/PieChartsPage';
import ProgramCardsSample from 'components/PepwiseV2DemoDashboard/ProgramCards';
import RichTextEditorPage from 'components/PepwiseV2DemoDashboard/RichTextEditorPage';
import TableDemoPage from 'components/PepwiseV2DemoDashboard/TableDemoPage';
import TabularView from 'components/PepwiseV2DemoDashboard/TabularView';
import PrivateRoute from 'utils/privateRoute';

const DemopepwiseV2DashboardRoutes = [
  {
    key: 'collapsible-menu-page',
    route: '/demo-dashboard/collapsible-menu',
    component: (
      <PrivateRoute
        Component={() => <DemoDashboardWithWidgets widget="collapsible-menu" />}
        // restrictedRoles={['D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'metric-cards-page',
    route: '/demo-dashboard/metric-cards',
    component: (
      <PrivateRoute
        Component={() => <DemoDashboardWithWidgets widget="metric-cards" />}
        // restrictedRoles={['D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'demov2-dashboard',
    route: '/demo-dashboard',
    component: (
      <PrivateRoute
        Component={DemoDashboardHome}
        // restrictedRoles={[ 'D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'pie-charts-page',
    route: '/demo-dashboard/pie',
    component: (
      <PrivateRoute
        Component={PieChartsPage}
        // restrictedRoles={['D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'bar-charts-page',
    route: '/demo-dashboard/bar',
    component: (
      <PrivateRoute
        Component={BarChartsPage}
        // restrictedRoles={['Platform Operations Admin/SRE', 'D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'table-demo-page',
    route: '/demo-dashboard/table',
    component: (
      <PrivateRoute
        Component={TableDemoPage}
        // restrictedRoles={['Platform Operations Admin/SRE', 'D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'kpiTiles-demo-page',
    route: '/demo-dashboard/kpi-tiles',
    component: (
      <PrivateRoute
        Component={KpiTilePage}
        // restrictedRoles={['Platform Operations Admin/SRE', 'D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'lineCharts-demo-page',
    route: '/demo-dashboard/lineCharts',
    component: (
      <PrivateRoute
        Component={LineChartsPage}
        // restrictedRoles={['Platform Operations Admin/SRE', 'D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'metricWidgets-demo-page',
    route: '/demo-dashboard/metricCountWidgets',
    component: (
      <PrivateRoute
        Component={MetricPage}
        // restrictedRoles={['Platform Operations Admin/SRE', 'D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'advanceFilters-demo-page',
    route: '/demo-dashboard/AdvanceFilters',
    component: (
      <PrivateRoute
        Component={AdvanceFilters}
        // restrictedRoles={['Platform Operations Admin/SRE', 'D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'programCards-demo-page',
    route: '/demo-dashboard/program-cards',
    component: (
      <PrivateRoute
        Component={ProgramCardsSample}
        // restrictedRoles={['Platform Operations Admin/SRE', 'D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'tabular-view-demo-page',
    route: '/demo-dashboard/tabular-view',
    component: (
      <PrivateRoute
        Component={TabularView}
        // restrictedRoles={['Platform Operations Admin/SRE', 'D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'KpiCards-demo-page',
    route: '/demo-dashboard/kpi-program-cards',
    component: (
      <PrivateRoute
        Component={KPICardsDemoPage}
        // restrictedRoles={['Platform Operations Admin/SRE', 'D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'formInput-demo-page',
    route: '/demo-dashboard/form-inputs',
    component: (
      <PrivateRoute
        Component={FormInputsPage}
        // restrictedRoles={['Platform Operations Admin/SRE', 'D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'rich-text-editor-page',
    route: '/demo-dashboard/rich-text-editor',
    component: (
      <PrivateRoute
        Component={RichTextEditorPage}
        // restrictedRoles={['Platform Operations Admin/SRE', 'D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'modal-demo-page',
    route: '/demo-dashboard/modals',
    component: (
      <PrivateRoute
        Component={ModalsPage}
        // restrictedRoles={['Platform Operations Admin/SRE', 'D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'modal-demo-page',
    route: '/demo-dashboard/modals',
    component: (
      <PrivateRoute
        Component={ModalsPage}
        // restrictedRoles={['Platform Operations Admin/SRE', 'D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'buttons-demo-page',
    route: '/demo-dashboard/buttons',
    component: (
      <PrivateRoute
        Component={ButtonsPage}
        // restrictedRoles={['Platform Operations Admin/SRE', 'D&AI Executive User', 'Program Executive']}
      />
    ),
  },
];

export default DemopepwiseV2DashboardRoutes;
